import React, { Component } from 'react';

class EarnDiscount extends Component {
  render() {
    return (
      <div className="fm-container">
        <p className="fm-webview-text">You can earn ride discounts by successfully inviting friends to ride who are new to Flamingo. You can do this by sharing your referral code under the “Payment” tab.</p>
      </div>
    );
  }
}

export default EarnDiscount;
